import React, { useRef, useEffect } from "react";
import { useState } from "react";
import { useApp } from "../../../contexts";
import {
  itemsSearch,
} from "../../../services/app";
import { IconSelectSearch } from "../../../components/Icons/IconSelectSearch";
import { IconSelectClose } from "../../../components/Icons/IconSelectClose";
let timeout;
let currentValue;

export default function SelectAvatar(props) {
    const { selectedItem, handleChangeVal } = props;
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);
    const [keyword, setKeyword] = useState('');
    const [isShowDropdown, setShowDropdown] = useState(false);
    const {T} = useApp();
    const [nftOptions, setNFTOptions] = useState([]);

    const searchItems = () => {
      itemsSearch({ keyword: keyword, page: 1, size: 20, itemTypes: [9] }).then(
        (res) => {
          if (currentValue === keyword) {
            const options = (res?.data?.data?.items?.rows || []).map(
              (item) => ({
                value: item.id,
                img: item.img,
                label: item.name,
              })
            );
            setNFTOptions(options);
          }
        }
      );
    };

    const fecthNftItems = async (keyword) => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      currentValue = keyword;

      if (keyword) {
        timeout = setTimeout(searchItems, 300);
      } else {
        setNFTOptions([]);
      }
    };
    useEffect(() => {
      searchItems();
    }, [])
    useEffect(() =>{
      fecthNftItems(keyword);
    }, [keyword])
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowDropdown(false)
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);
    const onSelectItem = (option) => {
      setShowDropdown(false)
      handleChangeVal(option)
    }
    const handleClear = () => {
      onSelectItem({})
      inputRef?.current?.focus();
      setKeyword('')
      searchItems();
      setShowDropdown(true)
    }
    const randomClass = (itemData) => {
      const arr = Array.from({ length: 7 }, (_, i) => i + 1);
      const random = itemData?.value % 7;
      return `suzu-card-image-${arr[random]}`
    }

    return (
      <div ref={wrapperRef} className="relative w-full sm:w-[250px]">
        <div className="input-search relative">
          <div className="input-search-prefix absolute left-[12px] top-[12px]">
            <IconSelectSearch />
          </div>
          {selectedItem.value ? <div  className="h-[40px] w-full pl-[40px] lg:max-w-full bg-white rounded-[10px] text-black">
            <div className="flex justify-between pr-[15px] items-center gap-4 leading-[40px] truncate">
              {T('Avatar ID: #{eanerId}').replace('{eanerId}', selectedItem.value )} <IconSelectClose onClick={() => handleClear()} />
            </div>
          </div>: <input
            className="h-[40px] w-full pl-[40px] lg:max-w-full py-3 bg-white rounded-[10px] text-black"
            placeholder={T('Search Avatar ID/Name')}
            ref={inputRef}
            onChange={(e) => setKeyword(e.target.value)}
            onClick={() => setShowDropdown(true)}
            value={keyword}
          />}
        </div>
        <div
          className={`absolute top-[45px] left-0 bg-white w-full rounded-[8px] ${isShowDropdown ? 'block' : 'hidden'} z-10`}
        >
          <div className="input-search-list">
            {nftOptions?.length == 0 ? <>
              <div className="px-[15px]">{T('No option match')}</div>
            </>: <>
              {nftOptions?.map((option) => <>
                <div
                    className="input-search-item cursor-pointer"
                    onClick={() => onSelectItem(option)}
                  >
                    <div className={`input-search-item-img ${randomClass(option)}`}>
                      <img src={option.img} alt="" />
                    </div>
                    <div className="input-search-item-label">
                      <div className="text-base text-black leading-[22px] truncate">{option.label}</div>
                      <div className="text-xs text-[#818181] leading-[20px] mt-[2px]">#{option.value}</div>
                    </div>
                  </div>
              </>)}
            </>}
            
          </div>
        </div>
      </div>
    );
}
